<template>
  <div class="w-full">
    <div v-if="client === 'client2tenant'">
      <div
        class="cursor-not-allowed bg-bluegray-300 h-10 flex items-center rounded relative shadow border border-bluegray-300 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 ml-3 mr-4 text-bluegray-700"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          />
        </svg>
        <p>Home</p>
      </div>
      <div
        v-if="settings.description && settings.description.length > 0"
        class="cursor-not-allowed bg-bluegray-300 h-10 flex items-center rounded relative shadow border border-bluegray-300 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 ml-3 mr-4 text-bluegray-700"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          />
        </svg>
        <p>About Us</p>
      </div>
      <div
        class="cursor-not-allowed bg-bluegray-300 h-10 flex items-center rounded relative shadow border border-bluegray-300 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 ml-3 mr-4 text-bluegray-700"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          />
        </svg>
        <p>Posts</p>
      </div>
    </div>
    <div v-else>
      <div
        class="cursor-not-allowed bg-truegray-300 h-10 flex items-center rounded relative shadow border border-truegray-300 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 ml-3 mr-4 text-truegray-700"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          />
        </svg>
        <p>Home</p>
      </div>
      <div
        class="cursor-not-allowed bg-truegray-300 h-10 flex items-center rounded relative shadow border border-truegray-300 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 ml-3 mr-4 text-truegray-700"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          />
        </svg>
        <p>News</p>
      </div>
      <div
        class="cursor-not-allowed bg-truegray-300 h-10 flex items-center rounded relative shadow border border-truegray-300 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 ml-3 mr-4 text-truegray-700"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          />
        </svg>
        <p>Events</p>
      </div>
      <div
        class="cursor-not-allowed bg-truegray-300 h-10 flex items-center rounded relative shadow border border-truegray-300 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 ml-3 mr-4 text-truegray-700"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          />
        </svg>
        <p>Jobs</p>
      </div>
    </div>

    <vue-nestable v-model="menu" :max-depth="2" @input="menuLoaded = true">
      <!-- blank placeholder by default, because we always have hardcoded pages/links in menu lists -->
      <div slot="placeholder" />
      <vue-nestable-handle
        slot-scope="{ item }"
        :item="item"
        class="flex justify-start w-full space-x-2 bg-gray-50 p-2 rounded border my-1"
      >
        <div class="flex justify-start w-full space-x-4">
          <button v-if="menu.length > 0" class="drag" type="button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 transition-all"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M3 7a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 13a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
          <span class="flex space-x-1 justify-center items-center">
            <span>{{ item.title }}</span>
            <svg
              v-if="item.page_type === 1"
              xmlns="http://www.w3.org/2000/svg"
              class="h-3 w-3 opacity-50"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              />
            </svg>

            <svg
              v-if="item.page_type === 2"
              xmlns="http://www.w3.org/2000/svg"
              class="h-3 w-3 opacity-50"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
              />
            </svg>
          </span>
        </div>
        <div
          v-if="item.status === 0"
          class="text-xs text-red-500 group cursor-pointer flex justify-center items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-3 w-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <div
            class="ml-2 text-xs absolute left-full top-0 w-24 z-50 border border-bluegray-300 rounded py-2 px-4 opacity-0 transition-all duration-300 transform pointer-events-none group-hover:opacity-100 bg-white text-center"
          >
            Draft
          </div>
        </div>
        <div class="group">
          <span v-if="item.page_type === 1">
            <svg
              :disabled="thinkingDelete"
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-gray-300 hover:text-gray-500 cursor-pointer transition-all duration-100"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              @click="deletePage(item.id)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
            <div
              class="ml-2 text-xs absolute left-full top-0 w-24 z-50 border border-truegray-300 rounded py-2 px-4 opacity-0 transition-all duration-300 transform pointer-events-none group-hover:opacity-100 bg-white text-center"
            >
              Delete link
            </div>
          </span>
          <span v-if="item.page_type === 2">
            <svg
              :disabled="thinkingDelete"
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-gray-300 hover:text-gray-500 cursor-pointer transition-all duration-100"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              @click="deletePage(item.id)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
            <div
              class="ml-2 text-xs absolute left-full top-0 w-24 z-50 border border-truegray-300 rounded py-2 px-4 opacity-0 transition-all duration-300 transform pointer-events-none group-hover:opacity-100 bg-white text-center"
            >
              Delete label
            </div>
          </span>
          <span v-if="item.page_type === 0 || !item.page_type">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-gray-300 hover:text-gray-500 cursor-pointer transition-all duration-100"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              @click="goToPage(item.id)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              />
            </svg>
            <div
              class="ml-2 text-xs absolute left-full top-0 w-24 z-50 border border-truegray-300 rounded py-2 px-4 opacity-0 transition-all duration-300 transform pointer-events-none group-hover:opacity-100 bg-white text-center"
            >
              Edit Page
            </div>
          </span>
        </div>
      </vue-nestable-handle>
    </vue-nestable>

    <div v-if="client === 'client2tenant'">
      <div
        v-if="settings.enabled_contact"
        class="cursor-not-allowed bg-bluegray-300 h-10 flex items-center rounded relative shadow border border-bluegray-300 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 ml-3 mr-4 text-bluegray-700"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          />
        </svg>
        <p>Contact</p>
      </div>
      <div
        class="cursor-not-allowed bg-bluegray-300 h-10 flex items-center rounded relative shadow border border-bluegray-300 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 ml-3 mr-4 text-bluegray-700"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          />
        </svg>
        <p>Back to Online Expo</p>
      </div>
    </div>

    <div class="w-full">
      <button
        :disabled="!canSaveMenu || menuThinking"
        :class="[
          !canSaveMenu ? 'opacity-25 border-black border' : 'btn-primary',
          menuThinking ? 'thinking-primary cursor-not-allowed' : '',
        ]"
        type="submit"
        class="btn mt-8 ml-auto relative"
        @click="saveMenu"
      >
        <div
          class="absolute inset-0 w-full flex justify-center items-center z-20"
        >
          <lottie v-if="menuThinking" :options="loadingAnimationOptions" />
        </div>
        <span :class="[menuThinking ? 'invisible' : '']">Save Changes</span>
      </button>
    </div>
    <!-- Menu Structure  -->
  </div>
</template>

<script>
import { shared } from '../../js/mixins/shared.js'
import { mapActions, mapGetters } from 'vuex'
import { EventBus } from '../../js/plugins/event-bus.js'
import { VueNestable, VueNestableHandle } from 'vue-nestable'
import * as loadingAnimation from '../../shared/components/loading.json'

export default {
  components: {
    VueNestable,
    VueNestableHandle,
  },

  display: 'Nested',
  order: 15,
  mixins: [shared],

  data() {
    return {
      component_id: false,
      menu: [],
      menu_original: [],
      canSaveMenu: false,
      menuLoaded: false,
      thinkingDelete: false,
      menuThinking: false,
      loadingAnimationOptions: { animationData: loadingAnimation.default },
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      client: 'shared/getClient',
    }),
  },

  watch: {
    menu: {
      // String option
      handler: function (val) {
        if (!this.menuLoaded) {
          return
        }

        if (val.length < 1 || this.menu_original.length < 1) {
          return
        }

        let thesame = this.isEquivalent(val, this.menu_original)
        if (thesame) {
          this.$set(this, 'canSaveMenu', false)
        } else {
          this.$set(this, 'canSaveMenu', true)
        }
      },

      deep: true,
    },
  },

  mounted() {
    this.$set(this, 'component_id', this.makeId())
    this.getManagerMenu()

    EventBus.$on('getManagerMenu', async () => {
      await this.getManagerMenu()
    })
  },

  methods: {
    ...mapActions({
      dispatchSetMenu: 'shared/dispatchSetMenu',
    }),

    getManagerMenu() {
      axios.get('/api/auth/get-manager-menu').then((response) => {
        if (response.data.menu && response.data.success) {
          this.$set(this, 'menu_original', response.data.menu)
          this.$set(this, 'menu', response.data.menu)
          this.$set(this, 'menuLoaded', false)
          this.dispatchSetMenu(response.data.menu)
        }
      })
    },

    deletePage(id = false) {
      if (!id) {
        return
      }
      this.$set(this, 'thinkingDelete', true)
      axios.get('/api/auth/delete-page/' + id).then((response) => {
        if (response.data.success) {
          this.getManagerMenu()
        }

        if (response.data.alert) {
          EventBus.$emit('triggerAlertResponse', response.data.alert)
        }

        this.$set(this, 'thinkingDelete', false)
      })
    },

    goToPage(id) {
      if (this.client === 'client2tenant') {
        this.$router.push({ path: '/manager/page/' + id })
      } else {
        this.$router.push({
          path: '/manager/pages/' + id,
          params: { post_id: id, edit: true },
        })
        // this.$router.push({name : 'Post', params: { post_id: id, edit: true } })
      }
    },

    isEquivalent(a, b) {
      // Create arrays of property names
      let aProps = Object.getOwnPropertyNames(a)
      let bProps = Object.getOwnPropertyNames(b)

      // If number of properties is different, objects are not equivalent
      if (aProps.length !== bProps.length) {
        return false
      }

      for (let i = 0; i < aProps.length; i++) {
        let propName = aProps[i]

        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
          return false
        }
      }

      // If we made it this far, objects are considered equivalent
      return true
    },

    // Drag and Drop methods
    saveMenu() {
      this.$set(this, 'menuThinking', true)
      axios
        .post('/api/auth/update-page-menu', { menu: this.menu })
        .then((response) => {
          this.$set(this, 'menuThinking', false)

          if (response.data.alert) {
            EventBus.$emit('triggerAlertResponse', response.data.alert)
          }

          if (response.data.success) {
            this.getManagerMenu()
          }
        })
    },
  },
}
</script>
